import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getPointSummary} from '../../../apis/point/getPointSummary'

const useQueryGetPointSummary = () => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.point.getPointSummary(),
        queryFn: async () => {
            const {data, pageInfo} = await getPointSummary()
            return {data, pageInfo}
        },
    })

    return {data: data?.data, refetch}
}

export default useQueryGetPointSummary
